export const LINE_OF_BUSINESS_HEADER = 'x-pt-lob';
export const CHAT_BOT_TOKEN_HEADER = 'x-pt-token';
